import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    informationStatus: 'wait',
    sortingRules: 'wait',
    breakRules: 'wait',
    exceptionRules: 'wait',
};

const ruleSetsStepsSlice = createSlice({
    name: 'ruleSetsSteps',
    initialState,
    reducers: {
        createRuleSetSteps: () => ({ ...initialState }),
        editRuleSetSteps: (_, action) => ({ ...action.payload }),
        setInformationStep: (state, action) => { state.informationStatus = action.payload; },
        setSortingRulesStep: (state, action) => { state.sortingRules = action.payload; },
        setBreakRulesStep: (state, action) => { state.breakRules = action.payload; },
        setExceptionRulesStep: (state, action) => { state.exceptionRules = action.payload; },
    },
});

export const informationStepStatusSelector = (state) => state.ruleSetsSteps.informationStatus;
export const sortingRulesStepStatusSelector = (state) => state.ruleSetsSteps.sortingRules;
export const breakRulesStepStatusSelector = (state) => state.ruleSetsSteps.breakRules;
export const exceptionRulesStepStatusSelector = (state) => state.ruleSetsSteps.exceptionRules;
export default ruleSetsStepsSlice;
